var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require('@/assets/i911-logo-2025.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }